import { useEffect, useState } from "react";
import { _DashBoard } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import SeriesCharts from "../../../../core/graph/SeriesCharts";

interface Props {
    kpi: any;
}
export const KpiViewer = ({ kpi }: Props) => {

    const _dashBoar = useDataBean(_DashBoard);
    const { bean, setBean, lista, setLista, instance, handleChange } = _dashBoar;
    const [report, setReport] = useState<any>({});

    const [xOption, setxOption] = useState<any>([]);
    const [yOption, setyOption] = useState<any>([]);
    const [head, setHead] = useState<any>([]);
    const [data, setData] = useState<any>([]);

    useEffect(() => {

        setBean(
            {
                xLength: 1,
                yLength: 1
            }
        )



    }, [kpi])
    useEffect(() => {

        if (report) {
            let xAxisProperties: any[] = report.XAxisProperties;
            if (xAxisProperties) {
                setxOption([...xAxisProperties]);
                let th = [];
                xAxisProperties.forEach(element => {
                    th.push(
                        {
                            title: element, property: element, visible: true
                        }
                    )
                });
                setHead(th);
            }
            if (report.List) {
                let td = [];
                report.List.forEach(element => {
                    td.push(
                        {
                            DataBeanProperties: element
                        }
                    )
                });
                setData(td);
            }
        }

    }, [report])

    const getDashBoardInfo = () => {
        if (bean.xLength && bean.yLength)
            instance.getKpiMeasurementTableForDashBoard(kpi.IDKpi, bean.xLength, bean.yLength, _single.getAccountID()).then(
                (resp: any) => {
                    setReport(resp);
                }
            )
        else {
            toast.warning("Faltan datos en el formulario");
        }
    }

    const getHeader =()=>{
        return(
             <div className="col-md-12">
                <p>
                    <strong>{kpi.IDKpi} - {kpi.Name}</strong> <small>({kpi.ProcessTypeName})</small> <br />
                    <small>{kpi.Description}</small>

                </p>
            </div>
        )
    }

    return (
        <div className="row">
           
            <div className="col-md-2">
                <label>Números de Períodos de Medición</label>
                <input type="number" name="xLength" id="xLength" value={bean.xLength} className="form-control" onChange={handleChange} />
            </div>
            <div className="col-md-2">
                <label>Número de Registros de Detalle</label>
                <input type="number" name="yLength" id="yLength" value={bean.yLength} className="form-control" onChange={handleChange} />
            </div>
            <div className="col-md-4">
                <BasicButton useMargin icon=" ri-file-search-fill" eventClick={getDashBoardInfo}>Buscar</BasicButton>
            </div>
            <div className="col-md- mt-3">

                {(report.List && report.XAxisProperties)  &&
                    <SeriesCharts
                        xAxisProperties={report.XAxisProperties}
                        list={report.List}
                        header={getHeader()}
                    />

                }

            </div>
            <div className="col-md-12">
               
            </div>
        </div>
    )
}